import { render, staticRenderFns } from "./FailureForm.vue?vue&type=template&id=a88a2650&scoped=true&"
import script from "./FailureForm.vue?vue&type=script&lang=js&"
export * from "./FailureForm.vue?vue&type=script&lang=js&"
import style0 from "./FailureForm.vue?vue&type=style&index=0&id=a88a2650&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a88a2650",
  null
  
)

export default component.exports